import { render, staticRenderFns } from "./ThrombolysisTime.vue?vue&type=template&id=35547b05&"
import script from "./ThrombolysisTime.vue?vue&type=script&lang=ts&"
export * from "./ThrombolysisTime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35547b05')) {
      api.createRecord('35547b05', component.options)
    } else {
      api.reload('35547b05', component.options)
    }
    module.hot.accept("./ThrombolysisTime.vue?vue&type=template&id=35547b05&", function () {
      api.rerender('35547b05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/ThrombolysisTime.vue"
export default component.exports